import { FC } from "react";
import { Paper } from "@mui/material";
import { StaticDatePicker } from "@mui/x-date-pickers-pro";
import CustomCalendarHeader from "src/Pages/Company/Absences/Calendars/Calendar/CalendarPicker/CustomCalendarHeader";
import CustomCalendarDay from "src/Pages/Company/Absences/Calendars/Calendar/CalendarPicker/CustomCalendarDay";
import CustomCalendarDayPreview from "src/Pages/Company/Absences/Calendars/Calendar/CalendarPicker/CustomCalendarDayPreview";
import {
  ICalendarPickerProps,
  CalendarPickerVariant,
} from "src/Pages/Company/Absences/Calendars/Calendars.models";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { absencesAbsencesConfigurationWrite } from "src/utils/RoleBasedSecurity/permissions";

const CalendarPicker: FC<ICalendarPickerProps> = ({
  year,
  month,
  excludedDays,
  excludedWeekDays,
  variant = CalendarPickerVariant.PICKER,
  handleCalendarDayAction,
}) => {
  const canWriteAbsencesConfiguration = usePermission(
    absencesAbsencesConfigurationWrite
  );
  const referenceDate = new Date().setFullYear(Number(year), month, 1);

  return (
    <Paper sx={{ p: "1rem 0 0 0" }}>
      <StaticDatePicker
        displayStaticWrapperAs="desktop"
        value={new Date(referenceDate)}
        disableHighlightToday
        readOnly={
          variant === CalendarPickerVariant.PREVIEW ||
          !canWriteAbsencesConfiguration
        }
        slots={{
          calendarHeader: CustomCalendarHeader,
          day: (props) => {
            if (
              variant === CalendarPickerVariant.PICKER &&
              canWriteAbsencesConfiguration
            ) {
              return CustomCalendarDay({
                excludedDays,
                excludedWeekDays,
                handleCalendarDayAction,
                ...props,
              });
            }
            return CustomCalendarDayPreview({
              excludedDays,
              ...props,
            });
          },
          actionBar: () => null,
        }}
        dayOfWeekFormatter={(date: Date) =>
          date.toLocaleString("pl", { weekday: "short" })
        }
        sx={{
          ".MuiDateCalendar-root": {
            justifyContent: "center",
          },
        }}
        data-testid="absences-calendar-picker"
      />
    </Paper>
  );
};

export default CalendarPicker;
